import axios from "axios";
import { getCountry } from "../lib/middleware";

export async function getCurrency() {
    const host =
        typeof window !== "undefined" ? window.location.hostname : "";
    if (host.startsWith("sa.") || getCountry() === "ksa") {
        return "SAR";
    }
    try {
        const response = await axios.get("/settings");
        return response.data?.data?.currency || "AED";
    } catch (error) {
        console.error(error);
        return "AED";
    }
}
